<template lang="pug">
div
  v-row.sysgrao-row
    v-col(v-for="card in summaryCards", :key="card.key", cols="12", md="3")
      summary-card(
        :title="card.title",
        :value="formatNumber(card.value)",
        :variant="card.variant",
        :icon="card.icon",
        :icon-variant="card.iconVariant"
      )

  v-row.sysgrao-row
    v-col(cols="12", md="6")
      v-card.panel-card(outlined)
        .panel-card__header
          span.panel-card__title Distribuição por sistema operacional
          v-btn.panel-card__expand.sysgrao-action-button(
            outlined,
            small,
            @click="dialogs.plataforma = true"
          )
            v-icon(small) mdi-arrow-expand

        v-card-text.panel-card__content
          apexchart.sysgrao-platform-chart(
            v-if="distribuicaoSeries.length",
            type="bar",
            :options="distribuicaoChartOptions",
            :series="distribuicaoSeries",
            height="100%"
          )
          .panel-card__empty(v-else)
            span Nenhum dado encontrado para o período selecionado.

    v-col(cols="12", md="6")
      v-card.panel-card(outlined)
        .panel-card__header
          span.panel-card__title Evolução de uso mobile
          v-btn.panel-card__expand.sysgrao-action-button(
            outlined,
            small,
            @click="dialogs.evolucao = true"
          )
            v-icon(small) mdi-arrow-expand

        v-card-text.panel-card__content
          apexchart.sysgrao-evolucao-chart(
            v-if="evolucaoSeries.length",
            :key="evolucaoRenderKey",
            type="line",
            :options="evolucaoChartOptions",
            :series="evolucaoSeries",
            height="100%"
          )
          .panel-card__empty(v-else)
            span Nenhum dado encontrado para o período selecionado.

    v-col(cols="12", md="12")
      v-card.panel-card(outlined)
        .panel-card__header
          span.panel-card__title Modelos de dispositivos mais usados
          v-btn.panel-card__expand.sysgrao-action-button(
            outlined,
            small,
            @click="dialogs.modelos = true"
          )
            v-icon(small) mdi-arrow-expand

        v-card-text.panel-card__content
          apexchart.sysgrao-modelos-chart(
            v-if="modelosPreview.series.length",
            :key="modelosRenderKey",
            type="bar",
            :options="modelosChartOptions",
            :series="modelosPreview.series",
            height="100%"
          )
          .panel-card__empty(v-else)
            span Nenhum dado encontrado para o período selecionado.

  v-dialog(
    :value="dialogs.plataforma",
    @input="dialogs.plataforma = $event",
    content-class="sysgrao-dialog-content",
    max-width="1200px",
    width="1200px"
  )
    v-card.panel-dialog
      .panel-card__header.panel-card__header--dialog
        span.panel-card__title Distribuição por sistema operacional
        v-btn(icon, @click="dialogs.plataforma = false")
          v-icon mdi-close
      v-card-text.panel-card__dialog-content.panel-card__dialog-content--scroll
        apexchart.sysgrao-platform-chart(
          v-if="distribuicaoSeries.length",
          type="bar",
          :options="distribuicaoDialogOptions",
          :series="distribuicaoSeries",
          height="520"
        )
        .panel-card__empty(v-else)
          span Nenhum dado encontrado para o período selecionado.

  v-dialog(
    :value="dialogs.evolucao",
    @input="dialogs.evolucao = $event",
    content-class="sysgrao-dialog-content",
    max-width="1200px",
    width="1200px"
  )
    v-card.panel-dialog
      .panel-card__header.panel-card__header--dialog
        span.panel-card__title Evolução de uso mobile
        v-btn(icon, @click="dialogs.evolucao = false")
          v-icon mdi-close
      v-card-text.panel-card__dialog-content.panel-card__dialog-content--scroll
        apexchart.sysgrao-evolucao-chart(
          v-if="evolucaoSeries.length",
          :key="evolucaoRenderKey",
          type="line",
          :options="evolucaoChartOptions",
          :series="evolucaoSeries",
          height="520"
        )
        .panel-card__empty(v-else)
          span Nenhum dado encontrado para o período selecionado.

  v-dialog(
    :value="dialogs.modelos",
    @input="dialogs.modelos = $event",
    content-class="sysgrao-dialog-content",
    max-width="1200px",
    width="1200px"
  )
    v-card.panel-dialog
      .panel-card__header.panel-card__header--dialog
        span.panel-card__title Modelos de dispositivos mais usados
        v-btn(icon, @click="dialogs.modelos = false")
          v-icon mdi-close
      v-card-text.panel-card__dialog-content.panel-card__dialog-content--scroll
        apexchart.sysgrao-modelos-chart(
          v-if="modelosAll.series.length",
          :key="modelosRenderKey",
          type="bar",
          :options="modelosDialogOptions",
          :series="modelosAll.series",
          height="auto"
        )
        .panel-card__empty(v-else)
          span Nenhum dado encontrado para o período selecionado.
</template>

<script>
import SummaryCard from "@/components/dashboards/shared/SummaryCard";

const OS_COLORS = {
  Dispositivos: "#3b4c63",
  Usuários: "#1e88e5",
  Modelos: "#2e7d32",
  "Ativos hoje": "#ff9f1c",
};
const EVOLUCAO_COLORS = { ativos: "#1565c0", novos: "#2e7d32" };
const MODELOS_COLORS = ["#5f6f84"];
const MODELOS_PREVIEW_LIMIT = 10;
const MODELOS_DIALOG_MIN_HEIGHT = 520;
const MODELOS_DIALOG_BAR_HEIGHT = 44;
const NUMBER_FORMATTERS = {
  integer: new Intl.NumberFormat("pt-BR"),
};

function toNumber(value) {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
}

function toArray(value) {
  return Array.isArray(value) ? value : [];
}

function createLocalDate(value) {
  const [year, month, day] = value.split("-").map(Number);
  return new Date(year, month - 1, day);
}

function formatDate(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

function shiftDays(date, amount) {
  const shifted = new Date(date);
  shifted.setDate(shifted.getDate() + amount);
  return shifted;
}

function normalizeDateValue(value) {
  if (!value) return "";
  const prefix = String(value).trim().slice(0, 10);
  if (/^\d{4}-\d{2}-\d{2}$/.test(prefix)) return prefix;
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? "" : formatDate(parsed);
}

const DATE_REGEX = /^\d{4}-\d{2}-\d{2}$/;

function buildDateTimeline(startDate, endDate) {
  if (!DATE_REGEX.test(startDate) || !DATE_REGEX.test(endDate)) return [];
  const dates = [];
  let current = createLocalDate(startDate);
  const final = createLocalDate(endDate);
  if (
    Number.isNaN(current.getTime()) ||
    Number.isNaN(final.getTime()) ||
    current > final
  )
    return [];
  while (current <= final) {
    dates.push(formatDate(current));
    current = shiftDays(current, 1);
  }
  return dates;
}

function createDistribuicaoOptions({ chartHeight, categories, formatInteger }) {
  return {
    chart: {
      type: "bar",
      height: chartHeight,
      parentHeightOffset: 0,
      toolbar: { show: false },
      animations: { enabled: true },
    },
    colors: [
      OS_COLORS["Dispositivos"],
      OS_COLORS["Usuários"],
      OS_COLORS["Modelos"],
      OS_COLORS["Ativos hoje"],
    ],
    plotOptions: {
      bar: { horizontal: false, borderRadius: 4, columnWidth: "70%" },
    },
    dataLabels: { enabled: false },
    grid: { borderColor: "#dfe7f5", strokeDashArray: 4 },
    legend: { show: true, position: "top", horizontalAlign: "center" },
    xaxis: {
      categories,
      axisBorder: { show: true },
      axisTicks: { show: true },
      labels: { style: { colors: "#5f6b7a", fontSize: "12px" } },
    },
    yaxis: {
      min: 0,
      labels: {
        formatter: (value) => formatInteger(value),
        style: { colors: "#5f6b7a", fontSize: "12px" },
      },
    },
    tooltip: {
      shared: true,
      intersect: false,
      y: { formatter: (value) => formatInteger(value) },
    },
  };
}

function buildEvolucaoSeries(evolucaoUso, startDate, endDate) {
  const dates = buildDateTimeline(startDate, endDate);
  if (!dates.length) return [];

  const ativosMap = {};
  const novosMap = {};
  toArray(evolucaoUso).forEach((item) => {
    const date = normalizeDateValue(item?.data);
    if (date) {
      ativosMap[date] = toNumber(item?.ativos);
      novosMap[date] = toNumber(item?.novos);
    }
  });

  const ativosData = dates.map((d) => ({
    x: `${d}T12:00:00`,
    y: ativosMap[d] || 0,
  }));
  const novosData = dates.map((d) => ({
    x: `${d}T12:00:00`,
    y: novosMap[d] || 0,
  }));

  if (!ativosData.some((p) => p.y > 0) && !novosData.some((p) => p.y > 0))
    return [];

  return [
    { name: "Ativos por dia", color: EVOLUCAO_COLORS.ativos, data: ativosData },
    { name: "Novos por dia", color: EVOLUCAO_COLORS.novos, data: novosData },
  ];
}

function createEvolucaoChartOptions({
  series,
  tickAmount,
  formatTimestampBR,
  formatInteger,
  animationsEnabled,
}) {
  return {
    chart: {
      type: "line",
      parentHeightOffset: 0,
      toolbar: { show: false },
      zoom: { enabled: false },
      animations: { enabled: animationsEnabled },
    },
    colors: series.map((s) => s.color),
    stroke: { curve: "monotoneCubic", width: 2 },
    markers: { size: 3, strokeWidth: 0, hover: { size: 5 } },
    grid: {
      borderColor: "#dfe7f5",
      strokeDashArray: 4,
      padding: { bottom: 12 },
    },
    dataLabels: { enabled: false },
    legend: { show: true, position: "top", horizontalAlign: "center" },
    xaxis: {
      type: "datetime",
      tickAmount,
      axisBorder: { show: true },
      axisTicks: { show: true },
      crosshairs: { show: true },
      tooltip: { enabled: false },
      labels: {
        rotate: 0,
        datetimeUTC: false,
        formatter: (value) => formatTimestampBR(value),
        style: { colors: "#5f6b7a", fontSize: "12px" },
      },
    },
    yaxis: {
      min: 0,
      forceNiceScale: true,
      labels: {
        formatter: (value) => formatInteger(value),
        style: { colors: "#5f6b7a", fontSize: "12px" },
      },
    },
    tooltip: {
      enabled: true,
      shared: true,
      intersect: false,
      followCursor: false,
      x: { show: true, formatter: (value) => formatTimestampBR(value) },
      y: { formatter: (value) => formatInteger(value) },
    },
  };
}

function buildModelosState(items, limit = Infinity) {
  const list = toArray(items)
    .filter((item) => item.modelo)
    .sort((a, b) => b.total - a.total)
    .slice(0, limit);
  return {
    categories: list.map((item) => item.modelo),
    series: list.length
      ? [{ name: "Dispositivos", data: list.map((item) => item.total) }]
      : [],
  };
}

function createModelosChartOptions({
  categories,
  colors,
  formatInteger,
  isMobile,
}) {
  return {
    chart: {
      type: "bar",
      parentHeightOffset: 0,
      toolbar: { show: false },
      animations: { enabled: true },
    },
    colors,
    plotOptions: {
      bar: {
        horizontal: true,
        distributed: true,
        borderRadius: 4,
        barHeight: "72%",
      },
    },
    states: { hover: { filter: { type: "darken", value: 0.08 } } },
    dataLabels: {
      enabled: !isMobile,
      formatter: (value) => formatInteger(value),
      style: { colors, fontSize: "12px", fontWeight: 600 },
      background: {
        enabled: true,
        foreColor: "#fff",
        borderRadius: 4,
        padding: 10,
        opacity: 0.8,
        borderWidth: 1,
        borderColor: "#d4dce8",
      },
    },
    grid: {
      borderColor: "#dfe7f5",
      strokeDashArray: 4,
      padding: isMobile ? { left: 0, right: 0 } : {},
    },
    legend: { show: false },
    xaxis: {
      categories,
      axisBorder: { show: true },
      axisTicks: { show: true },
      labels: {
        show: !isMobile,
        style: { colors: "#5f6b7a", fontSize: "12px" },
        formatter: (value) => formatInteger(value),
      },
    },
    yaxis: {
      labels: {
        show: !isMobile,
        maxWidth: 260,
        style: { colors: "#3d4b63", fontSize: "12px" },
      },
    },
    tooltip: {
      enabled: true,
      intersect: false,
      followCursor: false,
      y: { formatter: (value) => formatInteger(value) },
    },
  };
}

export default {
  name: "DispositivosGraosTab",

  components: {
    SummaryCard,
  },

  props: {
    isActive: { type: Boolean, default: false },
    totais: {
      type: Object,
      default: () => ({ notificacoes: 0, dispositivos: 0, android: 0, ios: 0 }),
    },
    plataforma: { type: Array, default: () => [] },
    evolucao: { type: Array, default: () => [] },
    modelos: { type: Array, default: () => [] },
    dataInicial: { type: String, default: "" },
    dataFinal: { type: String, default: "" },
  },

  data() {
    return {
      evolucaoChartRefreshTick: 0,
      modelosChartRefreshTick: 0,
      shouldAnimateEvolucao: true,
      dialogs: { plataforma: false, evolucao: false, modelos: false },
    };
  },

  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },

    summaryCards() {
      return [
        {
          key: "total-notificacoes",
          title: "Notificações mobile",
          value: toNumber(this.totais.notificacoes),
          variant: "success",
        },
        {
          key: "total-dispositivos",
          title: "Dispositivos",
          value: toNumber(this.totais.dispositivos),
          variant: "",
        },
        {
          key: "total-android",
          title: "Total Android",
          value: toNumber(this.totais.android),
          variant: "",
          icon: "mdi-android",
          iconVariant: "android",
        },
        {
          key: "total-ios",
          title: "Total iOS",
          value: toNumber(this.totais.ios),
          variant: "",
          icon: "mdi-apple",
          iconVariant: "ios",
        },
      ];
    },

    distribuicaoCategories() {
      return toArray(this.plataforma).map((item) => item.nome);
    },

    distribuicaoSeries() {
      const items = toArray(this.plataforma);
      if (!items.length) return [];
      const pluck = (key) => items.map((item) => toNumber(item[key]));
      const series = [
        { name: "Dispositivos", data: pluck("dispositivos") },
        { name: "Usuários", data: pluck("usuarios") },
        { name: "Modelos", data: pluck("modelos") },
        { name: "Ativos hoje", data: pluck("ativos_hoje") },
      ];
      const hasAnyValue = series.some((s) => s.data.some((v) => v > 0));
      return hasAnyValue ? series : [];
    },

    distribuicaoChartOptions() {
      return createDistribuicaoOptions({
        chartHeight: "100%",
        categories: this.distribuicaoCategories,
        formatInteger: (v) => this.formatNumber(v),
      });
    },

    distribuicaoDialogOptions() {
      return createDistribuicaoOptions({
        chartHeight: 520,
        categories: this.distribuicaoCategories,
        formatInteger: (v) => this.formatNumber(v),
      });
    },

    evolucaoSeries() {
      return buildEvolucaoSeries(
        this.evolucao,
        this.dataInicial,
        this.dataFinal
      );
    },

    evolucaoChartOptions() {
      const tickAmount = Math.min(
        Math.max(1, toArray(this.evolucaoSeries[0]?.data).length - 1),
        8
      );
      return createEvolucaoChartOptions({
        series: this.evolucaoSeries,
        tickAmount,
        formatTimestampBR: this.formatTimestampBR,
        formatInteger: (v) => this.formatNumber(v),
        animationsEnabled: this.shouldAnimateEvolucao,
      });
    },

    evolucaoRenderKey() {
      return [
        "evolucao",
        this.evolucaoChartRefreshTick,
        this.dataInicial,
        this.dataFinal,
      ].join("|");
    },

    modelosPreview() {
      return buildModelosState(this.modelos, MODELOS_PREVIEW_LIMIT);
    },

    modelosAll() {
      return buildModelosState(this.modelos);
    },

    modelosChartOptions() {
      return createModelosChartOptions({
        categories: this.modelosPreview.categories,
        colors: this.modelosPreview.categories.map(
          (_, i) => MODELOS_COLORS[i % MODELOS_COLORS.length]
        ),
        formatInteger: (v) => this.formatNumber(v),
        isMobile: this.isMobile,
      });
    },

    modelosDialogOptions() {
      const dialogHeight = Math.max(
        MODELOS_DIALOG_MIN_HEIGHT,
        this.modelosAll.categories.length * MODELOS_DIALOG_BAR_HEIGHT
      );
      return {
        ...createModelosChartOptions({
          categories: this.modelosAll.categories,
          colors: this.modelosAll.categories.map(
            (_, i) => MODELOS_COLORS[i % MODELOS_COLORS.length]
          ),
          formatInteger: (v) => this.formatNumber(v),
          isMobile: this.isMobile,
        }),
        chart: {
          type: "bar",
          height: dialogHeight,
          parentHeightOffset: 0,
          toolbar: { show: false },
        },
      };
    },

    modelosRenderKey() {
      return ["modelos", this.modelosChartRefreshTick].join("|");
    },
  },

  methods: {
    refreshEvolucaoCharts() {
      this.shouldAnimateEvolucao = true;
      this.evolucaoChartRefreshTick += 1;
    },

    formatNumber(value) {
      return NUMBER_FORMATTERS.integer.format(Math.round(toNumber(value)));
    },

    formatTimestampBR(value) {
      const date = normalizeDateValue(value);
      if (!date) return "";
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
  },

  watch: {
    isActive(value) {
      if (!value) return;
      this.$nextTick(() => {
        this.refreshEvolucaoCharts();
      });
    },

    evolucao() {
      this.$nextTick(() => {
        this.refreshEvolucaoCharts();
      });
    },

    modelos() {
      this.modelosChartRefreshTick += 1;
    },
  },

  mounted() {
    if (this.isActive) {
      this.$nextTick(() => {
        this.refreshEvolucaoCharts();
      });
    }
  },
};
</script>

<style scoped>
.sysgrao-row {
  margin-left: -6px !important;
  margin-right: -6px !important;
}

.sysgrao-row > [class*="col-"] {
  padding: 6px !important;
}

.panel-card {
  border-color: #d9e2ef !important;
  box-shadow: 0 2px 6px rgba(15, 42, 77, 0.08);
  border-radius: 18px 6px 18px 6px !important;
}

.panel-dialog {
  border-color: #d9e2ef !important;
  border-radius: 10px !important;
  box-shadow: 0 2px 6px rgba(15, 42, 77, 0.08);
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 100%;
  overflow: hidden;
}

.panel-card {
  display: flex;
  flex-direction: column;
  min-height: 490px;
  height: 490px;
  max-height: 490px;
}

.panel-card__header {
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: 16px 16px 0;
}

.panel-card__header--dialog {
  flex: 0 0 auto;
  padding: 16px;
}

.panel-card__title {
  color: #0a1f44;
  font-size: 16px;
  font-weight: 700;
}

.panel-card__expand {
  height: 30px !important;
  min-width: 36px !important;
  padding: 0 8px !important;
}

.panel-card__content {
  flex: 1 1 0;
  min-height: 0;
  padding-bottom: 16px !important;
}

.panel-card__dialog-content {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.panel-card__dialog-content--scroll {
  flex: 1 1 auto;
  min-height: 0;
  max-height: none;
  overflow-y: auto;
}

::v-deep .sysgrao-dialog-content .v-dialog {
  margin: 24px auto;
  height: calc(100vh - 48px);
  max-height: calc(100vh - 48px);
}

.panel-card__empty {
  align-items: center;
  color: #5f6b7a;
  display: flex;
  height: 100%;
  justify-content: center;
  min-height: 320px;
  text-align: center;
}

.sysgrao-action-button {
  border-color: #c7d1dc !important;
  box-shadow: none !important;
  color: #6f7d8c !important;
  font-size: 11px !important;
  font-weight: 500;
  letter-spacing: 0.01em !important;
  text-transform: none !important;
}

.sysgrao-action-button::before {
  background-color: transparent !important;
}

.sysgrao-action-button .v-icon {
  color: #748291 !important;
}

.sysgrao-modelos-chart ::v-deep .apexcharts-yaxis text {
  font-size: 12px;
}

@media (max-width: 959px) {
  .panel-card__header {
    align-items: flex-start;
    flex-direction: column;
    gap: 12px;
  }

  .panel-card__expand {
    align-self: flex-end;
  }
}
</style>
